import { ReactComponent as CloseIcon } from 'img/icons/close__1.svg';
import { ReactComponent as ArrowDownIcon } from 'img/icons/uploader/arrow_down.svg';
import { ReactComponent as ArrowUpIcon } from 'img/icons/uploader/arrow_up.svg';
import { ReactComponent as UploadIcon } from 'img/icons/uploader/uploader.svg';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUploadFromAction } from 'reactApp/modules/upload/upload.module';
import { Hint } from 'reactApp/ui/Hint/Hint';

import styles from './Controls.css';

const uploadIconSize = 20;
const closeIconSize = {
    width: 16,
    height: 16,
};
const expandIconSize = {
    width: 18,
    height: 10,
};

interface IProps {
    toggleExpand: boolean;
    progressComplete: boolean;
    showUploadButton: boolean;
    onExpand: () => void;
    onClose: () => void;
    onUpload: () => void;
}

export const Controls = memo(({ onExpand, toggleExpand, onClose, onUpload, progressComplete, showUploadButton }: IProps) => {
    const dispatch = useDispatch();

    const [icon, setIcon] = useState(<ArrowDownIcon {...expandIconSize} />);

    const changeIcon = useCallback(() => {
        if (toggleExpand) {
            setIcon(<ArrowUpIcon {...expandIconSize} />);
        } else {
            setIcon(<ArrowDownIcon {...expandIconSize} />);
        }
    }, [toggleExpand]);

    const onArrowClick = useCallback(() => {
        onExpand();
    }, [onExpand]);

    const onCloseClick = useCallback(() => {
        onClose();
    }, [onClose]);

    const onUploadClick = useCallback(() => {
        dispatch(setUploadFromAction('uploader'));
        onUpload();
    }, [onUpload]);

    useEffect(() => {
        changeIcon();
    }, [toggleExpand]);

    const closeText = progressComplete ? 'Закрыть' : 'Отменить все загрузки';

    return (
        <div className={styles.root}>
            {showUploadButton && (
                <Hint text="Загрузить ещё">
                    <div className={styles.upload} onClick={onUploadClick}>
                        <UploadIcon width={uploadIconSize} height={uploadIconSize} />
                    </div>
                </Hint>
            )}
            <Hint text={toggleExpand ? 'Развернуть' : 'Свернуть'}>
                <div className={styles.expand} onClick={onArrowClick}>
                    {icon}
                </div>
            </Hint>
            <Hint text={closeText}>
                <div className={styles.close} onClick={onCloseClick}>
                    <CloseIcon {...closeIconSize} />
                </div>
            </Hint>
        </div>
    );
});

Controls.displayName = 'UploadListControls';
